import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import HeaderLogo from "../../../components/header/headerLogo";
import "../../../assets/scss/tryforfree.scss";
import { Link } from "react-router-dom";
import verified from "../../../assets/images/verified.png";
import Repository from "../../../configs/axios/repository";
import Spinner from "../../../@core/components/spinner/Fallback-spinner";
import TryforfreeNoteTable from "../../../components/tables/tryforfreeNoteTable";
const Tryforfree = (props) => {
    const history = useHistory();
    const [notes, setNotes] = useState([]);
    const [loadingData, setLoadingData] = useState(false);

    const findNotes = async (skipTake) => {
        const result = await Repository.findByEndPoint(
            `api/notes/findNotesWithoutUserId`
        );
        if (result.data?.success) {
            setNotes(result.data.data);
            setLoadingData(true);
        }

        setLoadingData(true);
    };

    useEffect(() => {
        findNotes();
    }, []);

    return loadingData ? (
        <div className="tryforfreeParrent ">
            <div className="headerParent">
                <HeaderLogo />
            </div>
            <div className="tryForFreeSign">
                <button
                    onClick={() => {
                        history.push("/register");
                    }}
                >
                    SIGN UP
                </button>
            </div>
            {notes.length > 0 ? (
                <div className="noteSection">
                    <div className=" testH1">
                        <div id="yourNotes" className="mt-3 ">
                            <h1>Your Notes</h1>
                        </div>
                    </div>
                    <div>
                        <TryforfreeNoteTable
                            notes={notes}
                            setLoadingData={setLoadingData}
                            loadingData={loadingData}
                            canDoIt={false}
                        />
                    </div>
                </div>
            ) : (
                <div>
                    <h5 className="nodata">No data created yet.</h5>
                </div>
            )}
        </div>
    ) : (
        <div className="spinerHome">
            <Spinner spiner={true} />
        </div>
    );
};

export default Tryforfree;
